export default __webpack_public_path__ + "static/media/not_found.32c3bf4d.jpeg";